import { httpClient } from '../httpClient';
export class MnpRepository {
    // MNP予約番号一覧
    async getMnpReserveNumberList() {
        const { data } = await httpClient.get(`mnp/request/list/fetch`);
        return data;
    }
    // MNP予約番号
    async getMnpReserveNumber() {
        const { data } = await httpClient.get(`mnp/request/status/fetch`);
        return data;
    }
    async request() {
        const { data } = await httpClient.post(`mnp/request`);
        return data;
    }
    async cancel() {
        const { data } = await httpClient.put(`mnp/request/cancel`);
        return data;
    }
    async getMnpReserveNumberCustomer() {
        const { data } = await httpClient.get(`mnp/customer/fetch`);
        return data;
    }
    // MNP予約番号一覧（Premium）
    async getMnpReserveNumberListForPremium() {
        const { data } = await httpClient.get(`mnp/premium/request/list/fetch`);
        return data;
    }
    // MNP予約番号（Premium）
    async getMnpReserveNumberForPremium() {
        const { data } = await httpClient.get(`mnp/premium/request/status/fetch`);
        return data;
    }
    // MNP予約番号発行（Premium）
    async requestForPremium() {
        const { data } = await httpClient.post(`mnp/premium/request`);
        return data;
    }
}
